import _ from 'underscore';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import DialogInterface from '@/interfaces/dialog';
import template from '@/../templates/dialog-create-login-keys.hbs';

var MAX_DESCRIPTION_LENGTH = 300;

var view = Marionette.View.extend(DialogInterface).extend({
    id: 'create-invite-dialog',
    template: Handlebars.compile(template),
    ui: {
        current_password: '#current-password',
        description: '.description',
        load_spinner: '.loader',
        submit_btn: '.btn.btn-primary',
        form: 'form',
        description_length_counter: '.description-counter',
    },
    initialize: function (options) {
        this.destroyOnClose();
        this.focusFirstInput();
        this.success_callback = options.success;
    },
    events: {
        'keyup @ui.description': 'validateDescription',
        'submit form': 'onSubmit',
    },
    onSubmit: function (event) {
        event.preventDefault();

        var options = {
            current_password: this.ui.current_password.val(),
            description: this.ui.description.val(),
            success: _.bind(this.on_success, this),
            error: _.bind(this.on_error, this),
            wait: true,
        };

        this.model.create_login_key(options);
    },
    on_success: function (resp, message) {
        if (this.success_callback) this.success_callback(this.model, this.sent_values);
        this.closeDialog();
    },
    on_error: function (model, resp) {
        var err;
        try {
            err = resp.responseJSON.errors[0].detail;
        } catch (e) {
            console.error(e);
        }
        this.showAlert('error', err || 'Failed to generate login key');
    },
    validateDescription: function () {
        if (this.ui.description.val()) {
            this.check_validation(
                this.ui.description,
                MAX_DESCRIPTION_LENGTH,
                this.ui.description_length_counter,
                this.ui.submit_btn
            );
        } else {
            this.check_validation(
                this.ui.description,
                MAX_DESCRIPTION_LENGTH,
                this.ui.description_length_counter,
                this.ui.submit_btn
            );
            this.ui.submit_btn.prop('disabled', true);
        }
    },
});

export default view;

